import { useSubject, useAppStorage, useObservable } from '@aesop-fables/scrinium';
import { RevShareResult } from '../models/RevShareData';
import {
  OrgRevShareSettingsSubject,
  TeamRevShareSettingsSubject,
  GroupRevShareSettingsSubject,
} from '../data/rev-share/subjects/RevShareSettingsSubject';
import { AdminTierTypeEnum } from '../services/drillDown';
import { RevShareCompartments, revShareStorageKey } from '../data/rev-share';

export const useOrgRevShareSettings = () =>
  useSubject<RevShareResult | undefined>(OrgRevShareSettingsSubject);

export const useTeamRevShareSettings = () =>
  useSubject<RevShareResult | undefined>(TeamRevShareSettingsSubject);

export const useGroupRevShareSettings = () =>
  useSubject<RevShareResult | undefined>(GroupRevShareSettingsSubject);

export const useRevShareSettings = (adminTier: AdminTierTypeEnum | undefined) => {
  const orgRevShare = useOrgRevShareSettings();
  const teamRevShare = useTeamRevShareSettings();
  const groupRevShare = useGroupRevShareSettings();

  switch (adminTier) {
    case AdminTierTypeEnum.Organization:
      return orgRevShare;
    case AdminTierTypeEnum.Team:
      return teamRevShare;
    case AdminTierTypeEnum.Group:
      return groupRevShare;
    default:
      return undefined;
  }
};

export const useRevShareInitialized = (adminTier: AdminTierTypeEnum | undefined) => {
  const appStorage = useAppStorage();
  const revShareCache = appStorage.retrieve<RevShareCompartments>(revShareStorageKey);

  const orgInitialized = useObservable(
    revShareCache.findCompartment('orgRevShareSettings').initialized$,
  );
  const teamInitialized = useObservable(
    revShareCache.findCompartment('teamRevShareSettings').initialized$,
  );
  const groupInitialized = useObservable(
    revShareCache.findCompartment('groupRevShareSettings').initialized$,
  );

  switch (adminTier) {
    case AdminTierTypeEnum.Organization:
      return orgInitialized;
    case AdminTierTypeEnum.Team:
      return teamInitialized;
    case AdminTierTypeEnum.Group:
      return groupInitialized;
    default:
      return true;
  }
};
